import type {
  FlexProps} from '@chakra-ui/react'
import {
  Flex,
  forwardRef
} from '@chakra-ui/react'
import type { CompanyLogoProps } from '../CompanyLogo'
import { CompanyLogo } from '../CompanyLogo'

export interface RecapExtraHeaderProps extends FlexProps {
  logoProps?: CompanyLogoProps
  isEnabled?: boolean
  onStatusChange?: () => void
}

export const RecapExtraHeader = forwardRef(
  (
    {
      isEnabled,
      onStatusChange,
      logoProps,
      sx,
      ...rest
    }: RecapExtraHeaderProps,
    ref,
  ) => {
    return (
      <Flex
        ref={ref}
        sx={{
          px: 8,
          pr: 4,
          py: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          ...sx,
        }}
        {...rest}
      >
        {logoProps && <CompanyLogo  {...logoProps} />}

        {/* <Switch
          dir="rtl"
          size="lg"
          isChecked={isEnabled}
          onChange={onStatusChange}
        /> */}
      </Flex>
    )
  },
)
